import Modals from '../../../shared/types/enums/modals';
import TEmpty from '../templates/empty';
import { selectCurrentParams } from '../../../shared/store/slices/router.slice';
import { useAppSelector } from '../../../shared/store/hooks';

function Empty() {
  const currentParams = useAppSelector(selectCurrentParams);

  return (
    <TEmpty
      message={currentParams?.message as string}
      modal={currentParams?.modal as Modals}
    />
  );
}

export default Empty;
